import { render, staticRenderFns } from "./UiInfoBox.vue?vue&type=template&id=03713161&scoped=true"
import script from "./UiInfoBox.vue?vue&type=script&lang=ts"
export * from "./UiInfoBox.vue?vue&type=script&lang=ts"
import style0 from "./UiInfoBox.vue?vue&type=style&index=0&id=03713161&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03713161",
  null
  
)

export default component.exports